import React from "react";
import Button from "./atoms/Button";
import siteConfig from "../siteConfig";

/**
 * Click-to-call button sized to sit beside a "Schedule a Free Consultation"
 * Button, so the two read as one CTA row instead of the estimate/call pair being
 * stacked underneath as a second, duplicate-looking row.
 *
 * The number is resolved per city from siteConfig rather than passed in: Wyoming
 * and Jackson answer on their own lines, every other city on Battle Creek. That
 * keeps it consistent with the header, footer and LocalBusiness schema — mixed
 * NAP data across a page works against local SEO.
 *
 * `onDark` picks the white fill for the services grid's bg-neutral-800 band;
 * light sections get neutral-900, which is the pairing already used against the
 * red primary elsewhere on these pages (see city-cta-pair.js).
 */
const CityCallButton = ({ city, onDark = false, className = "" }) => {
  const phone = siteConfig.phoneForCity(city);

  return (
    <Button
      href={`tel:${siteConfig.phoneE164(phone)}`}
      size="big"
      color={onDark ? "secondary" : "primary"}
      className={className}
      aria-label={`Call the ${String(city || "").trim()} office at ${phone}`}
    >
      {phone}
    </Button>
  );
};

export default CityCallButton;
